// extracted by mini-css-extract-plugin
module.exports = {"innerLinks":"Events_innerLinks__3OimO","link":"Events_link__3sbP_","activeLink":"Events_activeLink__7PxAU"};